/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/main/docs/suggestions.md
 */

App.ready(() => App.scroll_here.init())

App.scroll_here = {

  init() {
    return $(document)
      .off("click focus", "[data-scroll-to], [data-scroll-to] *", App.scroll_here.clicked)
      .on("click focus", "[data-scroll-to], [data-scroll-to] *", App.scroll_here.clicked)
  },

  clicked(evt) {
    let selector
    evt.stopPropagation()

    // Get the target element
    const target = evt.currentTarget

    // Get the closest element with "data-scroll-to" attribute
    const el = target.closest("[data-scroll-to]")
    const scrollToElement = document.querySelector(el.getAttribute("data-scroll-to"))

    // Get the container, either from the "data-scroll-container" attribute or window
    const container = el.getAttribute("data-scroll-container") ?
      document.querySelector(el.getAttribute("data-scroll-container")) :
      window

    const difference = scrollToElement.getBoundingClientRect().top - container.getBoundingClientRect().top

    if (Math.abs(difference) > 5) {
      container.scrollTo({ top: difference, behavior: 'smooth' })
    }
  }

}
